import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { TranslationContext } from "../contexts/TranslationContext";
import { useContext } from "react";

// For authenticated users only
export const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { routes } = useContext(TranslationContext); // Get dynamic routes

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to={routes.login} />;
};

// For guests only
export const GuestRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { routes } = useContext(TranslationContext); // Get dynamic routes

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return !isAuthenticated ? children : <Navigate to={routes.home} />;
};
